/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import * as utm from "./utm.js";
import util from "../util/util.js";

export function gridCellIDFromLatLon(lat, lon, gridSize) {
  var p = utm.fromLatLon(lat, lon);
  return gridCellIDFromUtmPoint(p, gridSize);
}

export function gridCellIDFromUtmPoint(p, gridSize) {
  var x = Math.floor(p.easting / gridSize);
  var y = Math.floor(p.northing / gridSize);
  return [p.zoneNum, p.zoneLetter, "-", util.pad(x, 4), "-", util.pad(y, 4)].join("");
}

export function parseGridCellID(id) {
  var m = id.match(/([0-9]{2})([A-Z])-([0-9]{4})-([0-9]{4})/);
  if(m) {
    return {
      zoneNum: +m[1],
      zoneLetter: m[2],
      x: +m[3],
      y: +m[4]
    }
  }
}

export function gridCellCentroid(id, gridSize) {
  var c = parseGridCellID(id);
  if(c) {
    try {
      var p = utm.toLatLon(
        (c.x + 0.5) * gridSize,
        (c.y + 0.5) * gridSize,
        c.zoneNum,
        c.zoneLetter);
      return {
        lat: p.latitude,
        lon: p.longitude
      }
    } catch(e) { // do nothing
    }
  }
}

export function gridCellCorners(id, gridSize) {
  var c = parseGridCellID(id);
  if(c) {
    return [[0, 0], [0, 1], [1, 1], [1, 0]].map(function(xy) {
      var p = utm.toLatLon(
        (c.x + xy[0]) * gridSize,
        (c.y + xy[1]) * gridSize,
        c.zoneNum,
        c.zoneLetter);
      return {
        lat: p.latitude,
        lon: p.longitude
      };
    });
  }
}
